<template>
	<section>
		<div class="title">
			<div class="title-div">{{$t('all.duanyingyin')}}</div>
			<div class="fabu" @click="handleShowModal" v-if="videoTab===0 && appConfigInfo && appConfigInfo.videoReleasePermission==1">{{$t('all.fabuduanyingyin')}}</div>
		</div>
		<!-- 胶囊 tab：我发布的 / 我点赞的 / 我收藏的 -->
		<div class="dyy-tabs">
			<div class="dyy-tab-item" :class="videoTab===index?'dyy-tab-active':''" v-for="(item,index) in videoTabList" :key="index" @click="switchVideoTab(index)">
				<span :class="videoTab===index?'dyy-tab-text-active':'dyy-tab-text'">{{$t('all.' + item.key)}}</span>
			</div>
		</div>
		<div class="duanyingyin-list" v-if="videoList.length > 0">
			<div class="video-item" v-for="(item,index) in videoList" :key="item.id || index" @click="handlePlayVideo(item)">
				<img :src="item.coverUrl" class="video-item-img" />
				<div class="video-item-content">
					<span class="video-item-content-span">{{item.title || ''}}</span>
					<span class="video-item-content-span1">{{item.duration ? formatDuration(item.duration) : '00:00'}}</span>
				</div>
				<!-- 删除/撤回按钮只在我发布的 tab 显示 -->
				<img class="video-item-del" v-if="videoTab===0" src="../../assets/image/shanchu_18@2x.png" alt="" @click.stop="handleDeleteVideo(item)" />
				<!-- 审核状态标签只在我发布的 tab 显示 -->
				<div class="video-item-status" v-if="videoTab===0 && item.status != 1">{{item.status===0?$t('all.shenhezhong') :item.status ===2?$t('all.shenhejujue') :''}}</div>
			</div>
		</div>
		<kong v-if="!isLoading && loaded && videoList.length === 0" />
		
		<div class="modal-overlay" v-if="isModalVisible" @click="isModalVisible = false">
			<div class="modal-content" @click.stop>
				<div class="modal-title">{{$t('all.fabuduanyingyin')}}</div>
				<div class="modal-input-box">
					<input class="modal-input" v-model="form.title" type="text" :placeholder="$t('all.qingshurubiaoti')" />
				</div>
				<div class="modal-upload-box" @click="handleUploadClick">
					<div v-if="!form.videoUrl" class="modal-upload-content">
						<span class="modal-upload-text">{{$t('all.shangchuanduanyingyin')}}</span>
					</div>
					<div v-else class="modal-video-preview">
						<video :src="form.videoUrl" controls class="modal-video"></video>
						<span class="modal-video-name">{{form.videoName}}</span>
					</div>
				</div>
				<div v-if="uploading" class="modal-progress-box">
					<div class="modal-progress-bar">
						<div class="modal-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
					</div>
					<span class="modal-progress-text">{{uploadProgress.toFixed(1)}}%</span>
				</div>
				<div class="modal-btn" :class="{ disabled: !form.title || !form.videoUrl || uploading }" @click="handlePublish">发布</div>
				<input
				  type="file"
				  ref="fileInput"
				  style="display: none"
				  accept="video/mp4"
				  @change="handleFileChange"
				/>
			</div>
		</div>
	</section>
</template>

<script>
import { client as createCosClient } from '../../common/js/txycos';
import { getPresentUserVideoList, releaseVideo, deleteVideo, returnVideo } from '../../api/duanyingyin';
import { getPresentUserInfo, getUserCollectVideoList, getUserGiveLikeVideoList } from "@/api/user";
import kong from '../../components/kong/kong.vue';
export default {
	components: {
		kong
	},
	data() {
		return {
			isModalVisible: false,
			cosClient: null,
			appConfigInfo: null,
			// 短视频分类 tab: 0=我发布的 1=我点赞的 2=我收藏的
			videoTab: 0,
			form: {
				title: '',
				videoUrl: '',
				videoName: '',
				duration: 0,
				coverUrl: ''
			},
			uploading: false,
			uploadProgress: 0,
			videoList: [],
			queryParams: {
				page: 1,
				size: 10
			},
			hasMore: true,
			isLoading: false,
			loaded: false
		}
	},
	computed: {
		// tab 元信息：key 对应 i18n all.xxx
		videoTabList() {
			return [
				{ key: 'wofabu' },
				{ key: 'wodianzan' },
				{ key: 'woshoucang' }
			];
		}
	},
	mounted() {
		this.cosClient = createCosClient();
		this.getVideoList();
		this.getPresentUserInfo()
	},
	methods: {
		async getPresentUserInfo(){
			try {
				const res = await getPresentUserInfo()
				this.appConfigInfo = res.data
			} catch (e) {
				console.error('获取APP配置失败:', e)
			}
		},
		async getVideoList() {
			if (this.isLoading || !this.hasMore) return;
			this.isLoading = true;
			try {
				// 根据当前 tab 选择对应的接口：0=我发布的 1=我点赞的 2=我收藏的
				let apiFn;
				if (this.videoTab === 0) apiFn = getPresentUserVideoList;
				else if (this.videoTab === 1) apiFn = getUserGiveLikeVideoList;
				else apiFn = getUserCollectVideoList;

				const res = await apiFn(this.queryParams);
				const data = res.data || res;
				const newList = Array.isArray(data) ? data : (data.rows || data.list || []);
				if (this.queryParams.page === 1) {
					this.videoList = newList;
				} else {
					this.videoList = [...this.videoList, ...newList];
				}
				const total = data.total || newList.length;
				const totalPages = Math.ceil(total / this.queryParams.size);
				this.hasMore = this.queryParams.page < totalPages;
			} catch (error) {
				console.error('获取视频列表失败：', error);
			} finally {
				this.isLoading = false;
				this.loaded = true;
			}
		},
		// 切换分类 tab：重置分页并拉新数据
		switchVideoTab(tab) {
			if (this.videoTab === tab) return;
			this.videoTab = tab;
			this.queryParams.page = 1;
			this.hasMore = true;
			this.videoList = [];
			this.loaded = false;
			this.getVideoList();
		},
		// 供父组件调用的加载更多方法
		loadMore() {
			if (this.isLoading || !this.hasMore) return;
			this.queryParams.page++;
			this.getVideoList();
		},
		handleShowModal(){
			this.isModalVisible = true
			this.form = {
				title: '',
				videoUrl: '',
				videoName: '',
				duration: 0,
				coverUrl: ''
			}
			this.uploading = false
			this.uploadProgress = 0
		},
		handleUploadClick() {
			if(this.uploading) return
			this.$refs.fileInput.click();
		},
		handleFileChange(event) {
			const fileList = event.target.files;
			if (!fileList || fileList.length === 0) return;
			this.uploadVideoToCOS(fileList[0]);
			event.target.value = '';
		},
		async uploadVideoToCOS(file) {
			// 格式校验：仅允许 mp4
			const fileName = file.name || '';
			const fileExt = fileName.split('.').pop().toLowerCase();
			const isValidMp4 = file.type === 'video/mp4' || fileExt === 'mp4';
			if (!file || !isValidMp4) {
				this.$message.error(this.$t('all.zhishangchuanmp4'));
				return;
			}
			// 时长校验：先获取时长再判断是否在 10秒 ~ 60分钟 范围内
			try {
				const duration = await this.getVideoDuration(file);
				const MIN_DURATION = 10;
				const MAX_DURATION = 60 * 60;
				if (duration < MIN_DURATION || duration > MAX_DURATION) {
					this.$message.error(this.$t('all.shipinchangduxianzhi'));
					return;
				}
				this.form.duration = Math.floor(duration);
			} catch (e) {
				console.error('获取视频时长失败：', e);
				this.$message.error(this.$t('all.shipinchangduxianzhi'));
				return;
			}
			this.uploading = true;
			this.uploadProgress = 0;
			this.form.videoName = file.name;
			try {
				// 截取视频第一帧作为封面（用本地文件，避免远程地址跨域污染画布）
				let coverBlob = null;
				try {
					coverBlob = await this.getVideoCoverBlob(file);
				} catch (e) {
					console.error('获取视频封面失败：', e);
				}
				const fileExt = file.name.split('.').pop() || 'mp4';
				const fileName = `webStorage/web_/${Date.now()}_${Math.random().toString(36).substr(2, 10)}.${fileExt}`;
				const uploadResult = await new Promise((resolve, reject) => {
					this.cosClient.putObject({
						Bucket: this.cosClient.options.bucket,
						Region: this.cosClient.options.region,
						Key: fileName,
						Body: file,
						ContentType: file.type || 'video/mp4',
						onProgress: (progressData) => {
							this.uploadProgress = progressData.percent * 100;
						}
					}, (err, result) => {
						if (err) reject(err);
						else resolve(result);
					});
				});
				const videoUrl = `https://${this.cosClient.options.bucket}.cos.${this.cosClient.options.region}.myqcloud.com/${fileName}`;
				this.form.videoUrl = videoUrl;
				// 上传封面图，发布时作为 coverUrl 提交
				if (coverBlob) {
					const coverKey = `webStorage/web_/${Date.now()}_${Math.random().toString(36).substr(2, 10)}_cover.jpg`;
					await new Promise((resolve, reject) => {
						this.cosClient.putObject({
							Bucket: this.cosClient.options.bucket,
							Region: this.cosClient.options.region,
							Key: coverKey,
							Body: coverBlob,
							ContentType: 'image/jpeg'
						}, (err, result) => {
							if (err) reject(err);
							else resolve(result);
						});
					});
					this.form.coverUrl = `https://${this.cosClient.options.bucket}.cos.${this.cosClient.options.region}.myqcloud.com/${coverKey}`;
				}
				this.$message.success(this.$t('all.shangchuanzhong'));
			} catch (error) {
				console.error('视频上传失败：', error);
				this.$message.error(this.$t('all.shangchuanshibai'));
			} finally {
				this.uploading = false;
			}
		},
		getVideoDuration(file) {
			return new Promise((resolve, reject) => {
				const video = document.createElement('video');
				video.preload = 'metadata';
				video.onloadedmetadata = () => {
					resolve(video.duration);
					URL.revokeObjectURL(video.src);
				};
				video.onerror = () => {
					reject(new Error('无法获取视频时长'));
					URL.revokeObjectURL(video.src);
				};
				video.src = URL.createObjectURL(file);
			});
		},
		// 从本地视频文件截取第一帧，返回封面 Blob
		getVideoCoverBlob(file) {
			return new Promise((resolve, reject) => {
				const video = document.createElement('video');
				const url = URL.createObjectURL(file);
				video.preload = 'metadata';
				video.muted = true;
				video.playsInline = true;
				video.src = url;
				// 加载完首段数据后跳到第一帧位置
				video.onloadeddata = () => {
					try {
						video.currentTime = 0.1;
					} catch (e) {
						URL.revokeObjectURL(url);
						reject(e);
					}
				};
				// 跳帧完成，绘制到画布并导出图片
				video.onseeked = () => {
					try {
						if (!video.videoWidth || !video.videoHeight) {
							URL.revokeObjectURL(url);
							reject(new Error('无法读取视频画面'));
							return;
						}
						const canvas = document.createElement('canvas');
						canvas.width = video.videoWidth;
						canvas.height = video.videoHeight;
						canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
						canvas.toBlob((blob) => {
							URL.revokeObjectURL(url);
							if (blob) resolve(blob);
							else reject(new Error('生成封面失败'));
						}, 'image/jpeg', 0.8);
					} catch (e) {
						URL.revokeObjectURL(url);
						reject(e);
					}
				};
				video.onerror = () => {
					URL.revokeObjectURL(url);
					reject(new Error('视频加载失败'));
				};
			});
		},
		formatDuration(seconds) {
			const mins = Math.floor(seconds / 60);
			const secs = Math.floor(seconds % 60);
			return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
		},
		handleDeleteVideo(item) {
			const videoId = item.id || item.videoId;
			if (!videoId) {
				this.$message.error(this.$t('all.qingshurushuju'));
				return;
			}
			const status = item.status;
			let apiFunc = null;
			let confirmMsg = '';
			let successMsg = '';
			if (status === 1) {
				apiFunc = deleteVideo;
				confirmMsg = this.$t('all.confirmDelete') || '确认删除该视频？';
				successMsg = this.$t('all.shanchuchenggong') || '删除成功';
			} else if (status === 0) {
				apiFunc = returnVideo;
				confirmMsg = this.$t('all.confirmWithdraw') || '确认撤回该视频？';
				successMsg = this.$t('all.chehuichenggong') || '撤回成功';
			} else {
				this.$message.error('当前状态无法操作');
				return;
			}
			this.$confirm(confirmMsg).then(() => {
				apiFunc({ videoId }).then(res => {
					this.$message.success(res.msg);
					this.queryParams.page = 1;
					this.hasMore = true;
					this.getVideoList();
				}).catch(err => {
					this.$message.error(err.message || '操作失败');
				});
			}).catch(() => {});
		},
		handlePublish(){
			if(!this.form.title || !this.form.videoUrl){
				this.$message.error(this.$t('all.qingshurucontent'));
				return;
			}
			this.uploading = true;
			try {
				const params = {
					vo: {},
					title: this.form.title,
					videoUrl: this.form.videoUrl,
					coverUrl: this.form.coverUrl || '',
					duration: this.form.duration
				};
				releaseVideo(params).then(res => {
					this.$message.success(this.$t('all.fabuchenggong'));
					this.isModalVisible = false;
					this.queryParams.page = 1;
					this.hasMore = true;
					this.getVideoList();
					this.form = {
						title: '',
						videoUrl: '',
						videoName: '',
						duration: 0,
						coverUrl: ''
					};
				}).catch(err => {
					this.$message.error(err.message || this.$t('all.fabushibai'));
				}).finally(() => {
					this.uploading = false;
				});
			} catch (error) {
				this.uploading = false;
				this.$message.error(this.$t('all.fabushibai'));
			}
		},
		// 跳转视频播放详情页
		handlePlayVideo(item) {
			if (!item.videoUrl) return;
			this.$router.push({
				path: '/bofangshipin',
				query: {
					// 点赞/收藏 tab 取视频归属者 userId；我发布的 tab 无归属字段时 fallback 到当前登录用户
					userId: item.userId || item.createUserId || this.$store.state.userId || '',
					videoId: item.id || item.videoId || ''
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">
	.title{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 32px;
	}
	.title-div{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
	}
	/* 胶囊 tab 区域 */
	.dyy-tabs{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 16px;
	}
	.dyy-tab-item{
		padding: 9px 28px;
		background: rgba(255,255,255,0.08);
		border-radius: 999px;
		margin-right: 16px;
		cursor: pointer;
	}
	.dyy-tab-item.dyy-tab-active{
		background: rgba(54,154,255,0.15);
	}
	.dyy-tab-text{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,255,255,0.6);
		line-height: 20px;
	}
	.dyy-tab-text-active{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #369AFF;
		line-height: 20px;
	}
	.fabu{
		margin-left: 20px;
		padding: 9px 14px;
		background: linear-gradient( 86deg, #369AFF 0%, #8200CB 96.49%);
		border-radius: 18px;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		cursor: pointer;
	}
	.duanyingyin-list{
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		margin-top: 20px;
	}
	.kong{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		padding: 60px 0;
	}
	.video-item{
		width: calc((100% - 60px) / 5);
		margin: 0px 12px 12px 0px;
		display: flex;
		flex-direction: column;
		border-radius: 20px;
		overflow: hidden;
		position: relative;
		aspect-ratio: 3 / 4; 
		cursor: pointer;
	}
	.video-item-del{
		position: absolute;
		right: 6px;
		top: 6px;
		width: 18px;
		height: 18px;
		opacity: 0;
		transition: opacity 0.2s ease;
	}
	.video-item:hover .video-item-del{
		opacity: 1;
	}
	.video-item-status{
		position: absolute;
		top: 4px;
		left: 6px;
		padding: 2px 6px;
		background: rgba(0,31,37,0.4);
		border-radius: 9px;
		border: 1px solid rgba(0,217,255,0.26);
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 10px;
		color: #00D9FF;
	}
	.video-item-img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.video-item-content{
		position: absolute;
		left: 10px;
		right: 10px;
		bottom: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}
	.video-item-content-span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.video-item-content-span1{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	
	.modal-overlay{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0,0,0,0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 99;
	}
	.modal-content{
		width: 500px;
		background: #252632;
		border-radius: 20px;
		padding: 30px;
		box-shadow: 0px 4px 48px 0px rgba(0,0,0,0.5);
	}
	.modal-title{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 20px;
		color: #FFFFFF;
		text-align: center;
		margin-bottom: 20px;
	}
	.modal-input-box{
		margin-bottom: 15px;
	}
	.modal-input{
		width: 100%;
		height: 45px;
		background: rgba(255,255,255,0.1);
		border-radius: 10px;
		border: none;
		outline: none;
		padding: 0px 15px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		box-sizing: border-box;
	}
	.modal-input::placeholder{
		color: rgba(255,255,255,0.5);
	}
	.modal-upload-box{
		width: 100%;
		height: 300px;
		border: 2px dashed rgba(255,255,255,0.3);
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		margin-bottom: 15px;
		background: rgba(255,255,255,0.05);
		overflow: hidden;
	}
	.modal-upload-content{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.modal-upload-text{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #0A99F3;
	}
	.modal-video-preview{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.modal-video{
		width: 100%;
		height: 260px;
		object-fit: contain;
		border-radius: 5px;
	}
	.modal-video-name{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: rgba(255,255,255,0.6);
		margin-top: 8px;
	}
	.modal-progress-box{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 15px;
		gap: 10px;
	}
	.modal-progress-bar{
		flex: 1;
		height: 6px;
		background: rgba(255,255,255,0.2);
		border-radius: 3px;
		overflow: hidden;
	}
	.modal-progress-fill{
		height: 100%;
		background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
		border-radius: 3px;
		transition: width 0.2s ease;
	}
	.modal-progress-text{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,255,255,0.8);
		min-width: 60px;
		text-align: right;
	}
	.modal-btn{
		width: 100%;
		height: 50px;
		background: linear-gradient( 81deg, #369AFF 0%, #8200CB 88.07%);
		border-radius: 10px;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
		transition: opacity 0.3s ease;
	}
	.modal-btn.disabled{

	}
</style>


// WEBPACK FOOTER //
// duanyingyin.vue?5051bef0